import { useContext, createContext, useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import * as Config from '../../config/config';
import API from '../../api/client';
import * as ENDPOINTS from '../../api/endpoints';
import { LoaderContext } from "../../components/utils/Contexts";
import { CustomerData } from "../../components/utils/customers/CustomerData";
import i18n from "../../i18n";
const AuthContext = createContext();

const AuthProvider = ({ children }) => {
  const { isLoader, setLoader } = useContext(LoaderContext);
  const [customer, setCustomer] = useState(CustomerData.getCustomer());
  const [token, setToken] = useState(
    localStorage.getItem(Config.TOKEN_KEY) || sessionStorage.getItem(Config.TOKEN_KEY)
  );
  const navigate = useNavigate();
  const loginAction = async (dispatch, formData) => {
    try {
      const res = await API.post(ENDPOINTS.LOGIN, formData);
      setLoader(false);
      if (res.data) {
        setCustomer(res.data.data.customer);
        setToken(res.data.token);
        localStorage.setItem(Config.TOKEN_KEY, res.data.token);
        localStorage.setItem(Config.CUSTOMER_DATA_KEY, JSON.stringify(res.data.data.customer));
        if (res.data.data.customer.role == 3) {
          navigate(Config.REDIRECT_ORDER_APPROVAL_PAGE);
        } else {
          navigate(Config.REDIRECT_PAGE_AFTER_LOGIN);
        }
        return;
      }
      console.log('API LOGIN RESPONSE', res);
      if(res.response) {
        dispatch({
          type: 'invalid',
          message: res.response.data.message
        });
      }
    } catch (err) {
      console.log('err', err);
      dispatch({
        type: 'invalid',
        message: 'LOGIN FAILED'
      });
    }
  };

  const logOut = () => {
    setCustomer(null);
    setToken("");
    
    localStorage.removeItem(Config.TOKEN_KEY);
    localStorage.removeItem(Config.CUSTOMER_DATA_KEY);
    localStorage.clear();
    i18n.changeLanguage('en');
    navigate("/");
  };

  useEffect(() => {
    window.addEventListener(Config.TOKEN_KEY, storageEventHandler, false);

  }, []);

  const storageEventHandler = () => {
    if(!localStorage.getItem(Config.TOKEN_KEY)) {
      navigate("/");
    }
  }

  return (
    <AuthContext.Provider value={{ token, customer, loginAction, logOut }}>
      {children}
    </AuthContext.Provider>
  );

};

export default AuthProvider;

export const useAuth = () => {
  return useContext(AuthContext);
};